import { render, staticRenderFns } from "./OverlayRegisterComponent.vue?vue&type=template&id=c0f2222e&scoped=true"
import script from "./OverlayRegisterComponent.vue?vue&type=script&lang=js"
export * from "./OverlayRegisterComponent.vue?vue&type=script&lang=js"
import style0 from "./OverlayRegisterComponent.vue?vue&type=style&index=0&id=c0f2222e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f2222e",
  null
  
)

export default component.exports